/** */
import { urls } from 'services/_url';
import { apiGet, apiPost, apiPut } from 'services/_http';

/** */
const base_url = `${urls.agents}/v1/issues`;

export const create = async (options = {}) => {
  return await apiPost(`${base_url}`, { ...options });
};

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const readById = async (id, options = {}) => {
  return await apiGet(`${base_url}/${id}`, { ...options });
};

export const updateById = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}`, { ...options });
};

export const readReports = async (id, options = {}) => {
  return await apiGet(`${base_url}/${id}/reports`, { ...options });
};

export const searchByTitle = async (keyword, options = {}) => {
  return await apiGet(`${base_url}/search/title?keyword=${encodeURIComponent(keyword)}`, {
    ...options
  });
};
